import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import cashIcon from '../../../../assets/images/CashIcon.svg';
import RewardTemplateDetail from '../../../../components/shared/RewardTemplateDetail/RewardTemplateDetail';
import { CURRENCIES } from '../../../../constants/currenciesConstants';

import ReferralRewardHeading from './ReferralRewardHeading';

import styles from './ReferralRewardBadge.module.scss';

const ReferralRewardBadge = ({
  rewards = [],
  eligibileForRewards,
  monetaryRewardSum,
  user,
  showPublicRewards = false,
}) => {
  const { t } = useTranslation('common');
  const [isCollapsed, setIsCollapsed] = useState(
    !eligibileForRewards && !(showPublicRewards && !user),
  );

  const cashRewardWithCurrency = (cashRewardDetail) =>
    `${CURRENCIES[cashRewardDetail?.currency_id]}${cashRewardDetail.monetary_reward}`;

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={styles.mainContainer}>
      <ReferralRewardHeading
        eligibileForRewards={eligibileForRewards}
        user={user}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
        showToggleButton={!eligibileForRewards}
      />
      {!isCollapsed && (
        <div className={styles.rewardTypes}>
          {monetaryRewardSum && monetaryRewardSum.monetary_reward > 0 && (
            <RewardTemplateDetail
              icon={cashIcon}
              title={cashRewardWithCurrency(monetaryRewardSum)}
              text={t('buttons.cash')}
              classname={styles.verticalLine}
            />
          )}
          {rewards.map((singleReward) =>
            singleReward.map((reward) => (
              <React.Fragment key={uuidv4()}>
                {reward?.experiential_rewards_attributes &&
                  reward?.experiential_rewards_attributes.map((exper_reward) => (
                    <RewardTemplateDetail
                      key={uuidv4()}
                      icon={exper_reward.image}
                      title={exper_reward.name}
                      text={exper_reward.description}
                      classname={styles.verticalLine}
                    />
                  ))}
              </React.Fragment>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ReferralRewardBadge;
